<template>
<div class="page-wrapper">
    <div class="container-fluid">

        <!--div class="page-header d-print-none">
            <div class="container-xl">
                <div class="row align-items-center">
                    <div class="col">
                        <h2 class="page-title">
                            Home
                        </h2>
                    </div>
                </div>
            </div>
        </div-->

        <div class="page-body">
            <div class="container-xl">
                <div class="card">
                    <!--div class="card-body">
                        <div class="accordion" id="accordion-example">
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="heading-1">
                                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-1" aria-expanded="true">
                                        1. Create a Knowledge Base
                                    </button>
                                </h2>
                                <div id="collapse-1" class="accordion-collapse collapse show" data-bs-parent="#accordion-example" style="">
                                    <div class="accordion-body pt-0">
                                        Set up a repository of information for users
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="heading-2">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-2" aria-expanded="false">
                                        2. Add a Widget
                                    </button>
                                </h2>
                                <div id="collapse-2" class="accordion-collapse collapse" data-bs-parent="#accordion-example" style="">
                                    <div class="accordion-body pt-0">
                                        Generate and embed a widget, then share its URL.
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="heading-3">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-3" aria-expanded="false">
                                        3. Test the Widget
                                    </button>
                                </h2>
                                <div id="collapse-3" class="accordion-collapse collapse" data-bs-parent="#accordion-example" style="">
                                    <div class="accordion-body pt-0">
                                        Verify that the widget functions correctly.
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="heading-4">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-4" aria-expanded="false">
                                        4. Check the Inbox
                                    </button>
                                </h2>
                                <div id="collapse-4" class="accordion-collapse collapse" data-bs-parent="#accordion-example" style="">
                                    <div class="accordion-body pt-0">
                                        Review user interactions
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div-->

                    <div class="card-body overflow-auto pb-3">
                        <div class="row row-cards">
                            <div class="col-6 col-md-3" v-for="avatar in avatars" :key="avatar.id">
                                <div :class="'card position-relative cursor-pointer' + (detail.id === avatar.id ? 'card-active' : '')" @click.prevent="selectAvatar(avatar)">
                                    <div class="card-body p-0">
                                        <img :src="avatar.preview_image_url" class="avatar-image object-cover"/>
                                    </div>
                                    <div v-if="detail.id === avatar.id" class="position-absolute w-100 h-100 m-0 bg-primary opacity-50 backdrop-blur">
                                    </div>
                                    <div class="position-absolute avatar-name">
                                        <div class="badge bg-secondary-lt opacity-80">{{ avatar.title }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <modal ref="modal">
        <form @submit.prevent="save">
            <div class="modal-body" v-if="detail.preview_video_url">
                <video controls style="width: 100%; aspect-ratio: 16/9" :src="detail.preview_video_url"></video>
            </div>
            <div class="modal-body">
                <div class="mb-3">
                    <label class="form-label">Title</label>
                    <input type="text" class="form-control" ref="input" v-model="title" required />
                </div>
                <div class="mb-0">
                    <label class="form-label">Knowledge Base</label>
                    <textarea rows="15" required class="form-control" v-model="text" />
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary" type="submit">Create</button>
            </div>
        </form>
    </modal>

</div>
</template>

<script>
import api from "@/common/api";

export default {
    components: {

    },
    data() {
        return {
            loading: false,
            avatars: [],
            detail: {},
            title: "",
            text: ""
        };
    },
    mounted() {
        this.load();
    },
    methods: {
        save() {
            if (this.loading) {
                return;
            }

            this.loading = true;
            api.knowledgeCreate({ name: this.title, text: this.text }).then((knowledge) => {
                console.log(knowledge.id);
                api.widgetsCreate({ title: this.title, avatar_id: this.detail.id, knowledge_id: knowledge.id }).then(data => {
                    console.log(data);
                    this.$router.push({ name: "widgets" });
                }).catch(e => {
                    this.flashError(e);
                    this.loading = false;
                });
            }).catch(e => {
                this.flashError(e);
                this.loading = false;
            });
            /* this.loading = true;
            */
        },
        selectAvatar(avatar) {
            this.detail = avatar;
            console.log(avatar);
            this.$refs.modal.open();
        },
        load() {
            this.$store.dispatch("credit/update");

            api.avatars({}).then(data => {
                this.avatars = data.items;
            });
        }
    }
};
</script>
